import { useQuery } from "@tanstack/react-query";
import { getAdminAlerts } from "@/api/admin";
import { useAuthStore } from "@/store/auth";

/**
 * Unread admin-alert count for the sidebar badge (Sprint 142, TASK-4222).
 *
 * Deliberately shares the SAME query key as {@link AlertsBell} (`["admin",
 * "alerts"]`) so marking alerts read anywhere (bell dropdown, alerts inbox)
 * invalidates this query too and the badge updates for free — no extra polling
 * or manual invalidation. `select` narrows the payload to just `unread_count` so
 * the badge only re-renders when the count actually changes.
 *
 * Gated on the authenticated user being loaded (mirrors AlertsBell) so it never
 * fires during the brief post-login hydration window; polled every 60s.
 */
export function useAdminAlertsUnread(): number {
  const user = useAuthStore((s) => s.user);

  const { data } = useQuery({
    queryKey: ["admin", "alerts"],
    queryFn: () => getAdminAlerts(),
    enabled: Boolean(user),
    refetchInterval: 60_000,
    retry: 2,
    select: (d) => d.unread_count,
  });

  return data ?? 0;
}
